import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useDuplicateControlConfig = () =>
  useQuery<crmModels.IDuplicateControl>({
    queryKey: [crmConstants.queryKeys.DUPLICATE_CONTROL_CONFIG],
    queryFn: async () => {
      const res = await $api.get('/v1/duplicate-control/config');

      return res?.data?.data;
    }
  });
